import { getApiClient } from '@core/api/client';
import type { Team } from '@core/types/team/Team';
import type { ListTeamsResponse } from '@core/types/team/ListTeamsResponse';

export async function listChildTeams(parentId: string): Promise<Team[]> {
  const teams: Team[] = [];
  let cursor = '';
  do {
    const page = await getApiClient().get<ListTeamsResponse>('/team/full', {
      params: {
        'parent.id': parentId,
        include_secret: true,
        view: 0,
        'pagination.limit': 50,
        'pagination.direction': 'forward',
        ...(cursor ? { 'pagination.cursor': cursor } : {}),
      },
    });
    teams.push(...(page.teams?.teams ?? []));
    const info = page.pagination?.page_info;
    cursor = info?.has_next ? info.next_cursor ?? '' : '';
  } while (cursor);
  return teams;
}

export async function listDescendantTeams(rootId: string): Promise<Team[]> {
  const result: Team[] = [];
  const seen = new Set([rootId]);
  let current = [rootId];
  while (current.length) {
    const pages = await Promise.all(current.map(listChildTeams));
    const next: string[] = [];
    for (const page of pages) {
      for (const team of page) {
        const id = team.entity?.id;
        if (!id || seen.has(id)) continue;
        seen.add(id);
        result.push(team);
        next.push(id);
      }
    }
    current = next;
  }
  return result;
}
